/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      service — extends ember-keyboard's Service to suppress key-event
 *              propagation while an editable field (input/textarea/contenteditable)
 *              has focus, except for Escape/ArrowUp/ArrowDown
 *   extends:   Service (ember-keyboard/services/keyboard — addon's Service
 *              subclass, not @ember/service)
 *   template:  none
 *   key:       _respond(event) — the @action key handler that filters and then
 *              delegates to handleKeyEventWithPropagation
 *   uses:      ember-keyboard/utils/handle-key-event (handleKeyEventWithPropagation),
 *              @ember/runloop (run)
 *   siblings:  -
 *   tests:     keyboard-test.js
 */
import Service from 'ember-keyboard/services/keyboard';
import { action } from '@ember/object';
import { run } from '@ember/runloop';
import { handleKeyEventWithPropagation } from 'ember-keyboard/utils/handle-key-event';

export default class KeyboardService extends Service {
  @action
  _respond(event) {
    this._disableOnInput = true;

    if (this._disableOnInput && event.target) {
      const target = event.composedPath()[0] ?? event.target;
      const key = event.key;
      const tag = target.tagName;
      const isContentEditable =
        target.getAttribute && target.getAttribute('contenteditable') != null;

      if (
        key !== 'Escape' &&
        key !== 'ArrowDown' &&
        key !== 'ArrowUp' &&
        (isContentEditable || tag === 'TEXTAREA' || tag === 'INPUT')
      ) {
        return;
      }
    }
    run(() => {
      let { firstResponders, normalResponders } = this;
      handleKeyEventWithPropagation(event, {
        firstResponders,
        normalResponders,
      });
    });
  }
}
